import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ExchangeAvailabilityEffect } from './exchange-availability.effect';
import { exchangeAvailabilityReducer } from './exchange-availability.reducer';
import { EXCHANGE_AVAILABILITY_STORE_NAME, ExchangeAvailabilityState } from './exchange-availability.state';

/** Token of the ExchangeAvailability reducer */
export const EXCHANGE_AVAILABILITY_REDUCER_TOKEN = new InjectionToken<ActionReducer<ExchangeAvailabilityState, Action>>(
  'Feature ExchangeAvailability Reducer'
);

/** Provide default reducer for ExchangeAvailability store */
export function getDefaultExchangeAvailabilityReducer() {
  return exchangeAvailabilityReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(EXCHANGE_AVAILABILITY_STORE_NAME, EXCHANGE_AVAILABILITY_REDUCER_TOKEN),
    EffectsModule.forFeature([ExchangeAvailabilityEffect]),
  ],
  providers: [{ provide: EXCHANGE_AVAILABILITY_REDUCER_TOKEN, useFactory: getDefaultExchangeAvailabilityReducer }],
})
export class ExchangeAvailabilityStoreModule {
  public static forRoot<T extends ExchangeAvailabilityState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<ExchangeAvailabilityStoreModule> {
    return {
      ngModule: ExchangeAvailabilityStoreModule,
      providers: [{ provide: EXCHANGE_AVAILABILITY_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
